import React from 'react';
import {useSelector} from "react-redux";
import './ChoiceModal.scss';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    };
};

const ChoiceModal = props => {
    const { t } = useSelector(selector);
    const { text, confirmMethod, closeMethod, confirmButtonText, closeButtonText } = props;

    return (
        <div className='modalBlur'>
            <div className='ChoiceModal'>
                <div className='modalHeader'>
                    <span className="material-icons warningIcon">
                        error
                    </span>
                </div>
                <div className='modalForm'>
                    <div className='modalFormItem'>
                        {text}
                    </div>
                    <div className='modalFormButtons'>
                        <button className='modalFormButton modalFormButton--cancel' onClick={closeMethod}>
                            {closeButtonText ? t.gettext(closeButtonText) : t.gettext('CANCEL')}
                        </button>
                        <button className='modalFormButton' onClick={confirmMethod}>
                            {confirmButtonText ? t.gettext(confirmButtonText) : t.gettext('OK')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChoiceModal;
